export default {
  name: "components-loading"
};